import React from "react";
import { concepts } from "../mock";

function Icon({ name }) {
  if (name === "fire") {
    return (
      <svg className="ci" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M10 20c0-6 6-11 14-11s14 5 14 11-6 16-14 16-14-10-14-16Z" />
        <path d="M24 9V4M17 11l-2-4M31 11l2-4" />
      </svg>
    );
  }
  if (name === "tandoor") {
    return (
      <svg className="ci" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="9" y="16" width="24" height="20" rx="2" />
        <path d="M15 16v-3a9 9 0 0 1 18 0v3M20 24l3 4 5-6" />
      </svg>
    );
  }
  return (
    <svg className="ci" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 20h20l-1 8a9 9 0 0 1-18 0l-1-8Z" />
      <path d="M32 22h4a4 4 0 0 1 0 8h-3M17 12c0-2 2-2 2-4s-2-2-2-4M25 12c0-2 2-2 2-4s-2-2-2-4" />
    </svg>
  );
}

export default function Concept() {
  return (
    <section id="concept">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow" data-reveal="fade">How the room is split</span>
          <h2 data-reveal="fade" data-reveal-delay="1">One roof, three counters.</h2>
          <p data-reveal="fade" data-reveal-delay="2">
            Every order at Cloud9 comes from one of three stations — each run by someone who
            learned it before they learned to ride a bike.
          </p>
        </div>
        <div className="concept-grid">
          {concepts.map((c, i) => (
            <div className={`concept-card ${c.cls}`} key={c.title} data-reveal data-reveal-delay={String(i + 1)}>
              <Icon name={c.icon} />
              <span className="native">{c.native}</span>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
